import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1c54e3bd&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1c54e3bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54e3bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c54e3bd')) {
      api.createRecord('1c54e3bd', component.options)
    } else {
      api.reload('1c54e3bd', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1c54e3bd&scoped=true&", function () {
      api.rerender('1c54e3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FPykQaH1j6JR/JS/comp/GuestBox.vue"
export default component.exports